import { render, staticRenderFns } from "./suggestTheme.vue?vue&type=template&id=25dc0dd1&scoped=true&"
import script from "./suggestTheme.vue?vue&type=script&lang=js&"
export * from "./suggestTheme.vue?vue&type=script&lang=js&"
import style0 from "./suggestTheme.vue?vue&type=style&index=0&id=25dc0dd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dc0dd1",
  null
  
)

export default component.exports